import { defineMessages } from "react-intl";
const messages = defineMessages({
    communityTitle: {
        id: "app.admin.addCommunity.title.text",
        defaultMessage: "Create Community",
    },
});
export default messages;
